import { render } from "./CadastrarPlano.vue?vue&type=template&id=6c960bb2&scoped=true"
import script from "./CadastrarPlano.vue?vue&type=script&lang=js"
export * from "./CadastrarPlano.vue?vue&type=script&lang=js"

import "./CadastrarPlano.vue?vue&type=style&index=0&id=6c960bb2&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c960bb2"]])

export default __exports__